import { Observable } from 'rxjs';

/**
 * Creates an observable which will emit every time the passed in elements
 * gets resized. The event will contain a target: `Element`
 * and contentRect: `ResizeObserverEntry`
 *
 * @param elements The elements you want to get resize events for
 *
 * @example
 * return fromResize(titleElement).pipe(
 *   distinctUntilChanged()
 * ).subscribe(resize => {
 *   // The element just resized.
 *   // The resize variable contains the new dimensions.
 * });
 */
export function fromResize(
  ...elements: Element[]
): Observable<ResizeObserverEntry> {
  return new Observable((subscriber) => {
    const resizeObserver: ResizeObserver = new ResizeObserver(
      (observerEntries) => {
        // Trigger a new item on the stream when resizes happen.
        for (const entry of observerEntries) {
          subscriber.next(entry);
        }
      },
    );

    // Start listening for resize events.
    for (const element of elements) {
      resizeObserver.observe(element);
    }

    // Cancel resize observer on cancellation.
    return (): void => resizeObserver.disconnect();
  });
}
